import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Confrontation } from '../../shared';
import { TestCasesComponent } from './';

import { CanActivate } from '@angular/router';
import { AuthGuardService } from '../../shared';

// Route Configuration
const TestCasesRoutes: Routes = [
  // { 
  //   path: Confrontation.TESTCASES,
  //   component: ProjectsComponent,
  //   canActivate:[AuthGuardService]
  // },
  { 
    path: Confrontation.MYTESTCASES,
    component: TestCasesComponent,
    canActivate:[AuthGuardService]
  }
];

export const TestCasesRoutingProviders: any[] = [ AuthGuardService ];

export const TestCasesRouting: ModuleWithProviders = RouterModule.forChild(TestCasesRoutes)


// WEBPACK FOOTER //
// ./src/app/modules/test-cases/test-cases.routes.ts